export default {
  selectedCareer: state => state.selectedCareer
}
